// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dd-banner {
  display: block;
  width: 100%;
  margin: 0;
  padding: 12px 20px;
  border: 0;
  border-bottom: 1px solid #e7c98a;
  background: #fff6e0;
  color: #6b4a08;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}

.dd-banner:hover {
  background: #ffefc7;
}

body:not(.light_theme) .dd-banner {
  background: #3a2e14;
  border-bottom-color: rgba(209, 170, 103, 0.45);
  color: #f6e3b2;
}

.dd-statusStack {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  max-width: 220px;
}

.so-depHist_badge.dd-badgeLiteral,
.deposit_history_action_badge.dd-badgeLiteral,
.depositcrypto_lft .deposit_history_action_badge.dd-badgeLiteral {
  text-transform: none;
  white-space: normal;
  line-height: 1.35;
  text-align: center;
}

.dd-confirmBtn {
  border: 0.5px solid #d1aa67;
  background: #d1aa67;
  color: #000;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.2;
  border-radius: 999px;
  padding: 7px 12px;
  cursor: pointer;
}

.dd-confirmBtn:hover {
  filter: brightness(0.97);
}

.dd-page {
  max-width: 720px;
}

.dd-back {
  display: inline-flex;
  margin-bottom: 12px;
  color: inherit;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
}

.dd-card,
.dd-summary,
.dd-form {
  border: 1px solid #e6e8ec;
  border-radius: 16px;
  background: #fff;
  color: #1e2329;
}

.dd-card {
  padding: 20px 22px;
  margin-bottom: 16px;
}

.dd-amount {
  margin: 0 0 8px;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.dd-meta {
  margin: 0;
  display: grid;
  gap: 8px;
}

.dd-meta div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-size: 14px;
}

.dd-meta dt {
  margin: 0;
  color: #707a8a;
  font-weight: 500;
}

.dd-meta dd {
  margin: 0;
  text-align: right;
  word-break: break-all;
  font-weight: 600;
}

.dd-form,
.dd-summary {
  padding: 8px 22px 22px;
}

.dd-hold {
  margin: 0 0 8px;
  color: #707a8a;
  font-size: 14px;
}

.dd-question {
  margin: 0;
  padding: 16px 0;
  border: 0;
  border-bottom: 1px solid #eef0f2;
}

.dd-question legend,
.dd-field > span {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 700;
}

.dd-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dd-option,
.dd-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.dd-option input,
.dd-check input {
  margin-top: 2px;
}

.dd-names {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.dd-field {
  display: block;
  padding: 16px 0;
  border-bottom: 1px solid #eef0f2;
}

.dd-field input,
.dd-field select,
.dd-names input {
  width: 100%;
  box-sizing: border-box;
  min-height: 46px;
  padding: 10px 12px;
  border: 1px solid #e6e8ec;
  border-radius: 10px;
  background: #f7f8f9;
  color: inherit;
  font: inherit;
  font-size: 14px;
}

.dd-check {
  margin-top: 16px;
}

.dd-formError {
  margin: 12px 0 0;
  color: #b42318;
  font-size: 14px;
  font-weight: 600;
}

.dd-submit,
.dd-retry {
  margin-top: 16px;
  border: 0.5px solid #d1aa67;
  background: #d1aa67;
  color: #000;
  font-weight: 700;
  font-size: 15px;
  border-radius: 999px;
  padding: 12px 22px;
  cursor: pointer;
}

.dd-submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.dd-summaryRow {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px solid #eef0f2;
  font-size: 14px;
}

.dd-summaryRow span:first-child {
  color: #707a8a;
}

.dd-summaryRow span:last-child {
  text-align: right;
  font-weight: 600;
  word-break: break-word;
}

.dd-statusLine {
  margin: 16px 0 0;
  font-size: 14px;
}

body:not(.light_theme) .dd-card,
body:not(.light_theme) .dd-form,
body:not(.light_theme) .dd-summary {
  background: #1e2329;
  border-color: rgba(255, 255, 255, 0.08);
  color: #eaecef;
}

body:not(.light_theme) .dd-meta dt,
body:not(.light_theme) .dd-hold,
body:not(.light_theme) .dd-summaryRow span:first-child {
  color: #9aa4b2;
}

body:not(.light_theme) .dd-question,
body:not(.light_theme) .dd-field,
body:not(.light_theme) .dd-summaryRow {
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .dd-field input,
body:not(.light_theme) .dd-field select,
body:not(.light_theme) .dd-names input {
  background: #14181d;
  border-color: rgba(255, 255, 255, 0.12);
  color: #eaecef;
}

@media (max-width: 640px) {
  .dd-names {
    grid-template-columns: 1fr;
  }

  .dd-amount {
    font-size: 22px;
  }
}

.dd-modalRoot {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  z-index: 99999999999 !important;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.dd-modal {
  display: flex;
  flex-direction: column;
  width: min(420px, 100%);
  max-height: min(640px, calc(100vh - 48px));
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 20px 0 16px;
  border-radius: 16px;
  background: #1e202670;
  color: #ffffff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);
}

.dd-modalForm {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1;
}

.dd-modalScroll {
  overflow: auto;
  min-height: 0;
  padding: 0 24px;
}

.dd-modalHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding: 0 24px;
  flex: none;
}

.dd-modalHead h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #ffffff;
}

.dd-modalClose {
  border: 0;
  background: transparent;
  color: #e5e5e5;
  font-size: 28px;
  line-height: 1;
  padding: 0 2px;
  cursor: pointer;
}

.dd-modalFacts,
.dd-modalSummary,
.dd-modal > .dd-modalHint,
.dd-modal .dd-formError {
  padding-left: 24px;
  padding-right: 24px;
}

.dd-modalFacts {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0 0 14px;
  color: #c9c9c9;
  font-size: 13px;
  line-height: 1.4;
}

.dd-modalFacts strong {
  color: #fff;
  font-size: 14px;
}

.dd-modalHint,
.dd-modalHold {
  margin: 0 0 14px;
  color: #b6b6b6;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}

.dd-modalHold {
  margin-bottom: 8px;
  font-size: 13px;
}

.dd-modalSection {
  margin: 16px 0 10px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: #f7f7f7;
}

.dd-modalOptions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dd-modalChoice {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  color: #ebebeb;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  cursor: pointer;
}

.dd-modalChoice input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.dd-modalRadio {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  margin-top: 1px;
  box-sizing: border-box;
  border: 2px solid #b7bdc6;
  border-radius: 50%;
  background: #fff;
}

.dd-modalChoice.is-on .dd-modalRadio {
  border: 5px solid #1e2329;
}

.dd-modalField {
  display: block;
  margin-top: 14px;
}

.dd-modalField > span {
  display: block;
  margin-bottom: 8px;
  color: #e7e7e7;
  font-size: 14px;
  font-weight: 400;
}

.dd-modalField input,
.dd-modalField select {
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  background: #4b515d54;
  color: #f8f8f8;
  font: inherit;
  font-size: 14px;
}

.dd-modalField input::placeholder {
  color: #b7bdc6;
}

.dd-modalField select {
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #707a8a 50%), linear-gradient(135deg, #707a8a 50%, transparent 50%);
  background-position: calc(100% - 18px) 19px, calc(100% - 12px) 19px;
  background-size: 6px 6px, 6px 6px;
  background-repeat: no-repeat;
}

.dd-modalCheck {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  color: #e0e0e0;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
}

.dd-modalCheck input {
  margin-top: 2px;
}

.dd-modalActions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  padding: 0 24px;
  flex: none;
}

.withdraw_hist_detail_modal .dd-statusStack {
  align-items: end; }

.dd-modalCancel,
.dd-modalNext {
  flex: 1 1;
  height: 40px;
  border: 0;
  border-radius: 8px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.dd-modalCancel {
  background: #2d3748;
  color: #f3f3f3;
}

.dd-modalNext {
  background: #2d3748;
  color: #ffffff;
}

.dd-modalNext:disabled {
  background: #2d3748;
  color: #c5c8ce;
  cursor: not-allowed;
}

.dd-modalSummary {
  display: flex;
  flex-direction: column;
}

.dd-modalSummaryRow {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #eef0f2;
  font-size: 14px;
}

.dd-modalSummaryRow span:first-child {
  color: #707a8a;
}

.dd-modalSummaryRow span:last-child {
  text-align: right;
  font-weight: 600;
  word-break: break-word;
}

.dd-modalConfirmNote {
  margin: 14px 0 0;
  color: #474d57;
  font-size: 14px;
}

body.light_theme 
.dd-modalRoot {
    background-color: rgb(255 255 255 / 20%); }

body.light_theme .dd-modal {     background-color: rgba(255, 255, 255, 0.20);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px); }

body.light_theme .dd-modalHead h1 { color: #1e2329; }
body.light_theme .dd-modalClose { color: #1e2329; }
body.light_theme .dd-modalFacts { color: #1e2329; }
body.light_theme .dd-modalHint { color: #1e2329; }
body.light_theme .dd-modalHold { color: #1e2329; }
body.light_theme .dd-modalSection { color: #1e2329; }
body.light_theme .dd-modalOptions { color: #1e2329; }
body.light_theme .dd-modalChoice { color: #1e2329; }
body.light_theme .dd-modalField { color: #1e2329; }
body.light_theme .dd-modalCheck { color: #1e2329; }
body.light_theme .dd-modalActions { color: #1e2329; }
body.light_theme .dd-modalSummaryRow { color: #1e2329; }
body.light_theme .dd-modalConfirmNote { color: #1e2329; }
body.light_theme .dd-modalFacts strong {
  color: #000000; }

  body.light_theme .dd-modalField > span {
    color: #212121; }
    body.light_theme .dd-modalField input::placeholder {
        color: #707a8a; }
  body.light_theme .dd-modalField input, body.light_theme .dd-modalField select {
  background: #c7c7c754;
  color: #2c2c2c; }

@media (max-width: 767px) {

  .dd-modalRoot {
    align-items: end;
    padding: 24px 0px 0px; }

    .dd-modal { width: 100%; padding: 20px 0 24px; }

}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Order/depositDeclaration.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,8CAA8C;AAChD;;AAEA;;;EAGE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAO;AACT;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,6HAA6H;EAC7H,mEAAmE;EACnE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB,EAAE;;AAEpB;;EAEE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;IAEI,wCAAwC,EAAE;;AAE9C,iCAAiC,2CAA2C;EAC1E,2BAA2B;EAC3B,mCAAmC,EAAE;;AAEvC,oCAAoC,cAAc,EAAE;AACpD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD,oCAAoC,cAAc,EAAE;AACpD,oCAAoC,cAAc,EAAE;AACpD,mCAAmC,cAAc,EAAE;AACnD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,oCAAoC,cAAc,EAAE;AACpD,uCAAuC,cAAc,EAAE;AACvD,wCAAwC,cAAc,EAAE;AACxD;EACE,cAAc,EAAE;;EAEhB;IACE,cAAc,EAAE;IAChB;QACI,cAAc,EAAE;EACtB;EACA,qBAAqB;EACrB,cAAc,EAAE;;AAElB;;EAEE;IACE,gBAAgB;IAChB,qBAAqB,EAAE;;IAEvB,YAAY,WAAW,EAAE,oBAAoB,EAAE;;AAEnD","sourcesContent":[".dd-banner {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 12px 20px;\n  border: 0;\n  border-bottom: 1px solid #e7c98a;\n  background: #fff6e0;\n  color: #6b4a08;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: left;\n  cursor: pointer;\n}\n\n.dd-banner:hover {\n  background: #ffefc7;\n}\n\nbody:not(.light_theme) .dd-banner {\n  background: #3a2e14;\n  border-bottom-color: rgba(209, 170, 103, 0.45);\n  color: #f6e3b2;\n}\n\n.dd-statusStack {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  max-width: 220px;\n}\n\n.so-depHist_badge.dd-badgeLiteral,\n.deposit_history_action_badge.dd-badgeLiteral,\n.depositcrypto_lft .deposit_history_action_badge.dd-badgeLiteral {\n  text-transform: none;\n  white-space: normal;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.dd-confirmBtn {\n  border: 0.5px solid #d1aa67;\n  background: #d1aa67;\n  color: #000;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 1.2;\n  border-radius: 999px;\n  padding: 7px 12px;\n  cursor: pointer;\n}\n\n.dd-confirmBtn:hover {\n  filter: brightness(0.97);\n}\n\n.dd-page {\n  max-width: 720px;\n}\n\n.dd-back {\n  display: inline-flex;\n  margin-bottom: 12px;\n  color: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.dd-card,\n.dd-summary,\n.dd-form {\n  border: 1px solid #e6e8ec;\n  border-radius: 16px;\n  background: #fff;\n  color: #1e2329;\n}\n\n.dd-card {\n  padding: 20px 22px;\n  margin-bottom: 16px;\n}\n\n.dd-amount {\n  margin: 0 0 8px;\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.dd-meta {\n  margin: 0;\n  display: grid;\n  gap: 8px;\n}\n\n.dd-meta div {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  font-size: 14px;\n}\n\n.dd-meta dt {\n  margin: 0;\n  color: #707a8a;\n  font-weight: 500;\n}\n\n.dd-meta dd {\n  margin: 0;\n  text-align: right;\n  word-break: break-all;\n  font-weight: 600;\n}\n\n.dd-form,\n.dd-summary {\n  padding: 8px 22px 22px;\n}\n\n.dd-hold {\n  margin: 0 0 8px;\n  color: #707a8a;\n  font-size: 14px;\n}\n\n.dd-question {\n  margin: 0;\n  padding: 16px 0;\n  border: 0;\n  border-bottom: 1px solid #eef0f2;\n}\n\n.dd-question legend,\n.dd-field > span {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.dd-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dd-option,\n.dd-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.dd-option input,\n.dd-check input {\n  margin-top: 2px;\n}\n\n.dd-names {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.dd-field {\n  display: block;\n  padding: 16px 0;\n  border-bottom: 1px solid #eef0f2;\n}\n\n.dd-field input,\n.dd-field select,\n.dd-names input {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 46px;\n  padding: 10px 12px;\n  border: 1px solid #e6e8ec;\n  border-radius: 10px;\n  background: #f7f8f9;\n  color: inherit;\n  font: inherit;\n  font-size: 14px;\n}\n\n.dd-check {\n  margin-top: 16px;\n}\n\n.dd-formError {\n  margin: 12px 0 0;\n  color: #b42318;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.dd-submit,\n.dd-retry {\n  margin-top: 16px;\n  border: 0.5px solid #d1aa67;\n  background: #d1aa67;\n  color: #000;\n  font-weight: 700;\n  font-size: 15px;\n  border-radius: 999px;\n  padding: 12px 22px;\n  cursor: pointer;\n}\n\n.dd-submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.dd-summaryRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 0;\n  border-bottom: 1px solid #eef0f2;\n  font-size: 14px;\n}\n\n.dd-summaryRow span:first-child {\n  color: #707a8a;\n}\n\n.dd-summaryRow span:last-child {\n  text-align: right;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.dd-statusLine {\n  margin: 16px 0 0;\n  font-size: 14px;\n}\n\nbody:not(.light_theme) .dd-card,\nbody:not(.light_theme) .dd-form,\nbody:not(.light_theme) .dd-summary {\n  background: #1e2329;\n  border-color: rgba(255, 255, 255, 0.08);\n  color: #eaecef;\n}\n\nbody:not(.light_theme) .dd-meta dt,\nbody:not(.light_theme) .dd-hold,\nbody:not(.light_theme) .dd-summaryRow span:first-child {\n  color: #9aa4b2;\n}\n\nbody:not(.light_theme) .dd-question,\nbody:not(.light_theme) .dd-field,\nbody:not(.light_theme) .dd-summaryRow {\n  border-bottom-color: rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .dd-field input,\nbody:not(.light_theme) .dd-field select,\nbody:not(.light_theme) .dd-names input {\n  background: #14181d;\n  border-color: rgba(255, 255, 255, 0.12);\n  color: #eaecef;\n}\n\n@media (max-width: 640px) {\n  .dd-names {\n    grid-template-columns: 1fr;\n  }\n\n  .dd-amount {\n    font-size: 22px;\n  }\n}\n\n.dd-modalRoot {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  z-index: 99999999999 !important;\n  background-color: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.dd-modal {\n  display: flex;\n  flex-direction: column;\n  width: min(420px, 100%);\n  max-height: min(640px, calc(100vh - 48px));\n  overflow: hidden;\n  box-sizing: border-box;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  padding: 20px 0 16px;\n  border-radius: 16px;\n  background: #1e202670;\n  color: #ffffff;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);\n}\n\n.dd-modalForm {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1;\n}\n\n.dd-modalScroll {\n  overflow: auto;\n  min-height: 0;\n  padding: 0 24px;\n}\n\n.dd-modalHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding: 0 24px;\n  flex: none;\n}\n\n.dd-modalHead h1 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #ffffff;\n}\n\n.dd-modalClose {\n  border: 0;\n  background: transparent;\n  color: #e5e5e5;\n  font-size: 28px;\n  line-height: 1;\n  padding: 0 2px;\n  cursor: pointer;\n}\n\n.dd-modalFacts,\n.dd-modalSummary,\n.dd-modal > .dd-modalHint,\n.dd-modal .dd-formError {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.dd-modalFacts {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin: 0 0 14px;\n  color: #c9c9c9;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.dd-modalFacts strong {\n  color: #fff;\n  font-size: 14px;\n}\n\n.dd-modalHint,\n.dd-modalHold {\n  margin: 0 0 14px;\n  color: #b6b6b6;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.dd-modalHold {\n  margin-bottom: 8px;\n  font-size: 13px;\n}\n\n.dd-modalSection {\n  margin: 16px 0 10px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #f7f7f7;\n}\n\n.dd-modalOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dd-modalChoice {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0;\n  color: #ebebeb;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.4;\n  cursor: pointer;\n}\n\n.dd-modalChoice input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.dd-modalRadio {\n  flex: 0 0 18px;\n  width: 18px;\n  height: 18px;\n  margin-top: 1px;\n  box-sizing: border-box;\n  border: 2px solid #b7bdc6;\n  border-radius: 50%;\n  background: #fff;\n}\n\n.dd-modalChoice.is-on .dd-modalRadio {\n  border: 5px solid #1e2329;\n}\n\n.dd-modalField {\n  display: block;\n  margin-top: 14px;\n}\n\n.dd-modalField > span {\n  display: block;\n  margin-bottom: 8px;\n  color: #e7e7e7;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.dd-modalField input,\n.dd-modalField select {\n  width: 100%;\n  box-sizing: border-box;\n  height: 44px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 8px;\n  background: #4b515d54;\n  color: #f8f8f8;\n  font: inherit;\n  font-size: 14px;\n}\n\n.dd-modalField input::placeholder {\n  color: #b7bdc6;\n}\n\n.dd-modalField select {\n  appearance: none;\n  background-image: linear-gradient(45deg, transparent 50%, #707a8a 50%), linear-gradient(135deg, #707a8a 50%, transparent 50%);\n  background-position: calc(100% - 18px) 19px, calc(100% - 12px) 19px;\n  background-size: 6px 6px, 6px 6px;\n  background-repeat: no-repeat;\n}\n\n.dd-modalCheck {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-top: 16px;\n  color: #e0e0e0;\n  font-size: 14px;\n  line-height: 1.4;\n  cursor: pointer;\n}\n\n.dd-modalCheck input {\n  margin-top: 2px;\n}\n\n.dd-modalActions {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n  padding: 0 24px;\n  flex: none;\n}\n\n.withdraw_hist_detail_modal .dd-statusStack {\n  align-items: end; }\n\n.dd-modalCancel,\n.dd-modalNext {\n  flex: 1;\n  height: 40px;\n  border: 0;\n  border-radius: 8px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.dd-modalCancel {\n  background: #2d3748;\n  color: #f3f3f3;\n}\n\n.dd-modalNext {\n  background: #2d3748;\n  color: #ffffff;\n}\n\n.dd-modalNext:disabled {\n  background: #2d3748;\n  color: #c5c8ce;\n  cursor: not-allowed;\n}\n\n.dd-modalSummary {\n  display: flex;\n  flex-direction: column;\n}\n\n.dd-modalSummaryRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 0;\n  border-bottom: 1px solid #eef0f2;\n  font-size: 14px;\n}\n\n.dd-modalSummaryRow span:first-child {\n  color: #707a8a;\n}\n\n.dd-modalSummaryRow span:last-child {\n  text-align: right;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.dd-modalConfirmNote {\n  margin: 14px 0 0;\n  color: #474d57;\n  font-size: 14px;\n}\n\nbody.light_theme \n.dd-modalRoot {\n    background-color: rgb(255 255 255 / 20%); }\n\nbody.light_theme .dd-modal {     background-color: rgba(255, 255, 255, 0.20);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px); }\n\nbody.light_theme .dd-modalHead h1 { color: #1e2329; }\nbody.light_theme .dd-modalClose { color: #1e2329; }\nbody.light_theme .dd-modalFacts { color: #1e2329; }\nbody.light_theme .dd-modalHint { color: #1e2329; }\nbody.light_theme .dd-modalHold { color: #1e2329; }\nbody.light_theme .dd-modalSection { color: #1e2329; }\nbody.light_theme .dd-modalOptions { color: #1e2329; }\nbody.light_theme .dd-modalChoice { color: #1e2329; }\nbody.light_theme .dd-modalField { color: #1e2329; }\nbody.light_theme .dd-modalCheck { color: #1e2329; }\nbody.light_theme .dd-modalActions { color: #1e2329; }\nbody.light_theme .dd-modalSummaryRow { color: #1e2329; }\nbody.light_theme .dd-modalConfirmNote { color: #1e2329; }\nbody.light_theme .dd-modalFacts strong {\n  color: #000000; }\n\n  body.light_theme .dd-modalField > span {\n    color: #212121; }\n    body.light_theme .dd-modalField input::placeholder {\n        color: #707a8a; }\n  body.light_theme .dd-modalField input, body.light_theme .dd-modalField select {\n  background: #c7c7c754;\n  color: #2c2c2c; }\n\n@media (max-width: 767px) {\n\n  .dd-modalRoot {\n    align-items: end;\n    padding: 24px 0px 0px; }\n\n    .dd-modal { width: 100%; padding: 20px 0 24px; }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
